import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import MainWrapper from "../../helpers/MainWrapper2";
import MainHeader from "./amazon/MainHeader";
import CourierBand from "../../components/assets/CourierBand";
import WhySection from "./WhySection";
import LinksSection from "./LinksSection";
import ContactSection from "./ContactSection";
import "./styles.less";

declare var root: any;

const BusinessPage = () => {
  return (
    <>
      <MainWrapper menu={false} footer={true}>
        <MainHeader />
        {/* <CourierBand /> */}
        <WhySection />
        <LinksSection />
        <ContactSection />
      </MainWrapper>
    </>
  );
};

if (root) {
  ReactDOM.render(<BusinessPage />, root);
}
